<template>
  <div class="sui-locaing-indicator" v-show="httpReqCount">
    <div class="mid">  
      <span class="load"></span>
    </div>
  </div>
</template>

<script>
  export default {
    computed: {
      httpReqCount() {
        return this.$store.getters.httpReqCount;
      },
    },
  }
</script>

<style scoped lang="scss">
  // .sui-locaing-indicator {
  //   z-index:1000000;
  //   position: fixed;
  //   width: 100%;
  //   height: 100%;
  // }

//  .sui-loading-indicator--load-img {
//     width:80px;
//     height:80px;
//     background-size:80px;
//     top: calc(50% - 80px);
//     left: calc(50% - 40px);
//     /* background: none; */
//   }

$color: #3b80da;
$size: 60px;
$time1: 1s;
$time2: 1s;
$delay: -0.3s;
$num: 5; //edit also html
$thickness: 4px;
@mixin del ($items, $delay) {
   @for $i from 1 through ($items) {
       &-#{$i} {
         animation-delay: $delay*$i;
       }
    } 
}
* {
  box-sizing: border-box;
  margin: 0;
}

.mid {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50% );
}

.load {
  display: inline-block;
  width: $size;
  height: $size;
  border-radius: 50%;
  border: $thickness solid transparent;
  border-left: $thickness solid $color;
  border-top: $thickness solid $color;
  border-bottom: $thickness solid $color;
  animation: rotate $time1 linear infinite;
}

@keyframes scale {
  0% {transform: scale(1);}
  100% {transform: scale(0.1);}
}

@keyframes rotate {
  0% {transform: rotate(0deg);}
  100% {transform: rotate(360deg);}
}
</style>
